<h1 mat-dialog-title class="popup-component mat-dialog-title">
  <div class="title" matTooltip="{{title}}">{{title}}</div>
  <rfs2-icon name="cross" size="xs" class="clickable" (click)="close()">
  </rfs2-icon>
</h1>
<mat-divider></mat-divider>

<div mat-dialog-content class="mat-dialog-content">
  <div *ngIf='hasData ; else errorTextField'>
    <ng-container #data></ng-container>
  </div>
</div>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
